import { DomainPreferences } from '../../api/types';
import { DashboardConfig } from '../../common/components/dashboards/types';
import { getMomentDate } from '../../utils-date';
import { AlexDashboardChartConfig } from './alex_dashboard_config';
import { CreaturesDashboardChartConfig } from './creatures_dashboard_config';
import { JTBDashboardChartConfig } from './jtb_dashboard_config';
import { MixiHumanCapitalDashboardConfig } from './mixi/human-capital/human-capital-dashboard_config';
import { NikkiHeadcountDashboardConfig } from './nikki/headcount/nikki_headcount_dashboard_config';
import { NikkiTurnoverDashboardConfig } from './nikki/turnover/nikki_turnover_dashboard_config';
import { ShaqDashboardChartConfig } from './shaq_dashboard_config';
import { ShipHealthcareDashboardChartConfig } from './shiphealthcare_dashboard_config';
import { ShipHealthcareFixedTimeFrameDashboardChartConfig } from './shiphealthcare_fixed_timeframe_dashboard_config';
import { ValentinDashboardChartConfig } from './valentin_dashboard_chart_config';

const defaultDashboardConfigs: DashboardConfig[] = [];
const jtDashboardConfigs: DashboardConfig[] = [];
const shipHealthcareDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [
  ShipHealthcareDashboardChartConfig(domainPreferences),
  ShipHealthcareFixedTimeFrameDashboardChartConfig(domainPreferences, getMomentDate('2025-05-31').valueOf(), '2'),
  ShipHealthcareFixedTimeFrameDashboardChartConfig(domainPreferences, getMomentDate('2025-04-30').valueOf(), '3'),
];
const swanDashboardConfigs: DashboardConfig[] = [AlexDashboardChartConfig, ShaqDashboardChartConfig];
const allDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [
  AlexDashboardChartConfig,
  ShaqDashboardChartConfig,
  ValentinDashboardChartConfig,
  JTBDashboardChartConfig(domainPreferences),
];
const jtbDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [JTBDashboardChartConfig(domainPreferences)];
const creaturesDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [CreaturesDashboardChartConfig(domainPreferences)];
const nikkiDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [NikkiHeadcountDashboardConfig(domainPreferences), NikkiTurnoverDashboardConfig(domainPreferences)];
const mixiDashboardConfigs: (domainPreferences: DomainPreferences) => DashboardConfig[] = (
  domainPreferences: DomainPreferences
) => [MixiHumanCapitalDashboardConfig(domainPreferences)];
export const defaultDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(defaultDashboardConfigs);
export const jtDashboardConfigsJson = (domainPreferences: DomainPreferences) => JSON.stringify(jtDashboardConfigs);
export const creaturesDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(creaturesDashboardConfigs(domainPreferences));
export const shipHealthcareDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(shipHealthcareDashboardConfigs(domainPreferences));
export const jtbDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(jtbDashboardConfigs(domainPreferences));
export const swanDashboardConfigsJson = (domainPreferences: DomainPreferences) => JSON.stringify(swanDashboardConfigs);
export const nikkiDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(nikkiDashboardConfigs(domainPreferences));
export const mixiDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(mixiDashboardConfigs(domainPreferences));
export const allDashboardConfigsJson = (domainPreferences: DomainPreferences) =>
  JSON.stringify(allDashboardConfigs(domainPreferences));
